export const UserTypes = { // eslint-disable-line import/prefer-default-export
  INVESTOR: {
    label: 'Investor',
    name: 'INVESTOR',
  },
  FINANCIAL_ADVISOR: {
    label: 'Financial Advisor',
    name: 'ADVISOR',
  },
  MINOR: {
    label: 'Minor',
    name: 'MINOR',
  },
  ADMIN: {
    label: 'Admin',
    name: 'ADMIN',
  },
  INSTITUTIONAL_REPRESENTATIVE: {
    label: 'Institutional Representative',
    name: 'INSTITUTIONAL_REPRESENTATIVE',
  },
  READ_ONLY: {
    label: 'Read-only',
    name: 'READ_ONLY',
  },
};



// WEBPACK FOOTER //
// ./src/data/static/userTypes.js